import Vue from "vue";
import VueRouter from "vue-router";
import login from "@/views/login.vue";
import notFound from '@/views/404.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })

Vue.use(VueRouter);

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => { })
}

const routes = [
  {
    path: "/",
    name: "/",
    component: login,
    redirect: '/login',
    meta: {
      title: '登录',
      breadList: ['登录'],
    },
  },
  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      title: '登录',
      breadList: ['登录'],
    },
  },
  {
    path: "/seeLivev2",
    name: "seeLivev2",
    component: () =>
      import(/* webpackChunkName: "seeLivev2" */ "../views/seeLivev2.vue"),
    meta: {
      title: '课堂旁听',
      breadList: ['课堂旁听'],
    },
  },
  {
    path: "/seeLivev3",
    name: "seeLivev3",
    component: () =>
      import(/* webpackChunkName: "seeLivev3" */ "../views/seeLivev3.vue"),
    meta: {
      title: '课堂旁听',
      breadList: ['课堂旁听'],
    },
  },
  {
    path: "/otherTest",
    name: "otherTest",
    component: () =>
      import(/* webpackChunkName: "otherTest" */ "../views/otherTest.vue"),
    meta: {
      title: '测试页面',
      breadList: ['测试页面'],
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => {
      return import(/* webpackChunkName: "homeTypeAll" */ "../views/homeTypeAll.vue")
    },

    meta: {
      title: '首页',
      breadList: ['首页'],
    },
    children: [
      {
        path: "/welcome",
        name: "welcome",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "welcome" */ "../views/welcome.vue"),
        meta: {
          title: '首页',
          breadList: ['首页'],
        },
      },
      /* 更新记录 */
      {
        path: "/updateLogs",
        name: "updateLogs",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "updateLogs" */ "../views/updateLogs.vue"),
        meta: {
          title: '更新记录',
          breadList: ['更新记录'],
        },
      },
      /* ai测试页面 */
      /* 测试PC话机 */
      {
        path: "/test/pcCallBoxTest",
        name: "pcCallBoxTest",
        component: () =>
          import(/* webpackChunkName: "pcCallBoxTest" */ "../views/test/pcCallBoxTest.vue"),
        meta: {
          title: '测试PC话机',
          breadList: ['测试PC话机'],
        },
      },
      /* 阿里AI实时对话 */
      {
        path: "/ai/rtcCallTestAl",
        name: "rtcCallTestAl",
        component: () =>
          import(/* webpackChunkName: "rtcCallTestAl" */ "../views/ai/rtcCallTestAl.vue"),
        meta: {
          title: '实时通话Al',
          breadList: ['实时通话Al'],
        },
      },
      /* 字节AI实时对话 */
      {
        path: "/ai/rtcCallTestZj",
        name: "rtcCallTestZj",
        component: () =>
          import(/* webpackChunkName: "rtcCallTestZj" */ "../views/ai/rtcCallTestZj.vue"),
        meta: {
          title: '实时通话Zj',
          breadList: ['实时通话Zj'],
        },
      },
      /* 火山AI实时对话 */
      {
        path: "/ai/rtcCallTestHs",
        name: "rtcCallTestHs",
        component: () =>
          import(/* webpackChunkName: "rtcCallTestHs" */ "../views/ai/rtcCallTestHs.vue"),
        meta: {
          title: '实时通话Hs',
          breadList: ['实时通话Hs'],
        },
      },
      /* 即构AI实时对话 */
      {
        path: "/ai/rtcCallTestJg",
        name: "rtcCallTestJg",
        component: () =>
          import(/* webpackChunkName: "rtcCallTestJg" */ "../views/ai/rtcCallTestJg.vue"),
        meta: {
          title: '实时通话Jg',
          breadList: ['实时通话Jg'],
        },
      },
      /* 即构测试对话记录 */
      {
        path: "/ai/jgAiTestCallRecord",
        name: "jgAiTestCallRecord",
        component: () =>
          import(/* webpackChunkName: "jgAiTestCallRecord" */ "../views/ai/jgAiTestCallRecord.vue"),
        meta: {
          title: '测试对话记录',
          breadList: ['测试对话记录'],
        },
      },
      /* 测试对话思考时长 */
      {
        path: "/ai/aiTestCallThinkTimeRecord",
        name: "aiTestCallThinkTimeRecord",
        component: () =>
          import(/* webpackChunkName: "aiTestCallThinkTimeRecord" */ "../views/ai/aiTestCallThinkTimeRecord.vue"),
        meta: {
          title: '对话思考时长',
          breadList: ['对话思考时长'],
        },
      },
      /* ai历史聊天 */
      {
        path: "/ai/aiChatHistory",
        name: "aiChatHistory",
        component: () =>
          import(/* webpackChunkName: "aiChatHistory" */ "../views/ai/aiChatHistory.vue"),
        meta: {
          title: '历史分析',
          breadList: ['ai', '历史分析'],
        },
      },
      /* ai当前聊天 */
      {
        path: "/ai/aiChatCurrent",
        name: "aiChatCurrent",
        component: () =>
          import(/* webpackChunkName: "aiChatCurrent" */ "../views/ai/aiChatCurrent.vue"),
        meta: {
          title: '当前分析',
          breadList: ['ai', '当前分析'],
        },
      },
      /* ai分析 */
      {
        path: "/ai/aiAnalyse",
        name: "aiAnalyse",
        component: () =>
          import(/* webpackChunkName: "aiAnalyse" */ "../views/ai/aiAnalyse.vue"),
        meta: {
          title: 'ai分析',
          breadList: ['ai', 'ai分析'],
        },
      },
      /* ai反馈问题列表 */
      {
        path: "/ai/aiAudioAnalysisFeedbackList",
        name: "aiAudioAnalysisFeedbackList",
        component: () =>
          import(/* webpackChunkName: "aiAudioAnalysisFeedbackList" */ "../views/ai/aiAudioAnalysisFeedbackList.vue"),
        meta: {
          title: '反馈问题',
          breadList: ['ai', '反馈问题'],
        },
      },
      /* ai通用设置 */
      {
        path: "/ai/generalSituation",
        name: "generalSituation",
        component: () =>
          import(/* webpackChunkName: "generalSituation" */ "../views/ai/generalSituation.vue"),
        meta: {
          title: '综合情况',
          breadList: ['ai', '综合情况'],
        },
      },
      {
        path: "/ai/realTimeDataBoard",
        name: "realTimeDataBoard",
        component: () =>
          import(/* webpackChunkName: "realTimeDataBoard" */ "../views/ai/realTimeDataBoard.vue"),
        meta: {
          title: '实时看板',
          breadList: ['ai', '实时看板'],
        },
      },
      {
        path: "/ai/callVoiceManage",
        name: "callVoiceManage",
        component: () =>
          import(/* webpackChunkName: "callVoiceManage" */ "../views/ai/callVoiceManage.vue"),
        meta: {
          title: '音色管理',
          breadList: ['ai', '音色管理'],
        },
      },
      {
        path: "/ai/callTaskManage",
        name: "callTaskManage",
        component: () =>
          import(/* webpackChunkName: "callTaskManage" */ "../views/ai/callTaskManage.vue"),
        meta: {
          title: '任务管理',
          breadList: ['ai', '任务管理'],
        },
      },
      {
        path: "/ai/aiCommonSet",
        name: "aiCommonSet",
        component: () =>
          import(/* webpackChunkName: "aiCommonSet" */ "../views/ai/aiCommonSet.vue"),
        meta: {
          title: '通用设置',
          breadList: ['ai', '通用设置'],
        },
      },
      /* ai销售专员-录音分析 */
      {
        path: "/ai/saleAudioAnalysis",
        name: "saleAudioAnalysis",
        component: () =>
          import(/* webpackChunkName: "saleAudioAnalysis" */ "../views/ai/saleAudioAnalysis.vue"),
        meta: {
          title: '录音分析',
          breadList: ['ai', '录音分析'],
        },
      },
      /* ai销售专员-录音分析详情 */
      {
        path: "/ai/saleAudioAnalysisDetail",
        name: "saleAudioAnalysisDetail",
        component: () =>
          import(/* webpackChunkName: "saleAudioAnalysisDetail" */ "../views/ai/saleAudioAnalysisDetail.vue"),
        meta: {
          title: '录音分析详情',
          breadList: ['ai', '录音分析详情'],
        },
      },
      /* 讲师微信小程序后台页面 */
      /* 面试答题管理 */
      {
        path: "/teacherWxPage/questionManage",
        name: "questionManage",
        component: () =>
          import(/* webpackChunkName: "questionManage" */ "../views/teacherWxPage/questionManage.vue"),
        meta: {
          title: '面试答题管理',
          breadList: ['讲师小程序', '面试答题管理'],
        },
      },
      /* 升学资讯管理 */
      {
        path: "/teacherWxPage/newsManage",
        name: "newsManage",
        component: () =>
          import(/* webpackChunkName: "userManage" */ "../views/teacherWxPage/newsManage.vue"),
        meta: {
          title: '升学资讯管理',
          breadList: ['讲师小程序', '升学资讯管理'],
        },
      },
      /* 用户设置 */
      {
        path: "/userSetting/userManage",
        name: "set_userManage",
        component: () =>
          import(/* webpackChunkName: "userManage" */ "../views/sysManage/userManage.vue"),
        meta: {
          title: '用户管理',
          breadList: ['用户设置', '用户管理'],
        },
      },
      {
        path: "/userSetting/callAccountManage",
        name: "userSetting_callAccountManage",
        component: () =>
          import(/* webpackChunkName: "dataManage_callAccountManage" */ "../views/sales/dataManage/callAccountManage.vue"),
        meta: {
          title: '坐席分配',
          breadList: ['用户设置', '坐席分配'],
        },
      },
      {
        path: "/userSetting/callPlatformSet",
        name: "userSetting_callPlatformSet",
        component: () =>
          import(/* webpackChunkName: "dataManage_callPlatformSet" */ "../views/sales/dataManage/callPlatformSet.vue"),
        meta: {
          title: '电话设置',
          breadList: ['用户设置', '电话设置'],
        },
      },
      /* 系统 */
      {
        path: "/sysManage/menuManage",
        name: "menuManage",
        component: () =>
          import(/* webpackChunkName: "menuManage" */ "../views/sysManage/menuManage.vue"),
        meta: {
          title: '菜单管理',
          breadList: ['系统管理', '菜单管理'],
        },
      },
      {
        path: "/sysManage/roleManage",
        name: "roleManage",
        component: () =>
          import(/* webpackChunkName: "roleManage" */ "../views/sysManage/roleManage.vue"),
        meta: {
          title: '角色管理',
          breadList: ['系统管理', '角色管理'],
        },
      },
      {
        path: "/sysManage/userManage",
        name: "userManage",
        component: () =>
          import(/* webpackChunkName: "userManage" */ "../views/sysManage/userManage.vue"),
        meta: {
          title: '用户管理',
          breadList: ['系统管理', '用户管理'],
        },
      },
      {
        path: "/sysManage/areaManage",
        name: "areaManage",
        component: () =>
          import(/* webpackChunkName: "areaManage" */ "../views/sysManage/areaManage.vue"),
        meta: {
          title: '行政区域',
          breadList: ['系统管理', '区域管理'],
        },
      },
      {
        path: "/sysManage/publicSourceManage",
        name: "publicSourceManage",
        component: () =>
          import(/* webpackChunkName: "publicSourceManage" */ "../views/sysManage/publicSourceManage.vue"),
        meta: {
          title: '公共资源库',
          breadList: ['系统管理', '公共资源库'],
        },
      },
      {
        path: "/sysManage/macroManage",
        name: "macroManage",
        component: () =>
          import(/* webpackChunkName: "macroManage" */ "../views/sysManage/macroManage.vue"),
        meta: {
          title: '通用字典',
          breadList: ['系统管理', '通用字典'],
        },
      },
      {
        path: "/sysManage/organManage",
        name: "organManage",
        component: () =>
          import(/* webpackChunkName: "organManage" */ "../views/sysManage/organManage.vue"),
        meta: {
          title: '机构管理',
          breadList: ['系统管理', '机构管理'],
        },
      },
      /* 讲师 */
      {
        path: "/teacher/teacherManage/teacherList",
        name: "teacherManage_teacherList",
        component: () =>
          import(/* webpackChunkName: "teacherManage_teacherList" */ "../views/teacher/teacherManage/teacherList.vue"),
        meta: {
          title: '讲师列表',
          breadList: ['讲师', '讲师管理', '讲师列表'],
        },
      },
      {
        path: "/teacher/teacherAudit/teacherList",
        name: "teacherAudit_teacherList",
        component: () =>
          import(/* webpackChunkName: "teacherAudit_teacherList" */ "../views/teacher/teacherAudit/teacherList.vue"),
        meta: {
          title: '讲师列表',
          breadList: ['讲师', '讲师审核', '讲师列表'],
        },
      },
      {
        path: "/teacher/teacherAudit/adviserList",
        name: "teacherAudit_adviserList",
        component: () =>
          import(/* webpackChunkName: "teacherAudit_adviserList" */ "../views/teacher/teacherAudit/adviserList.vue"),
        meta: {
          title: '讲师顾问',
          breadList: ['讲师', '讲师审核', '讲师顾问'],
        },
      },
      {
        path: "/teacher/teacherAudit/teacherPreview",
        name: "teacherAudit_teacherPreview",
        component: () =>
          import(/* webpackChunkName: "teacherAudit_teacherPreview" */ "../views/teacher/teacherAudit/teacherPreview.vue"),
        meta: {
          title: '讲师概览',
          breadList: ['讲师', '讲师审核', '讲师概览'],
        },
      },
      /* 销售 */
      /* 商学院-前台 */
      /* 商学院-首页 */
      {
        path: "/sxyFront/home",
        name: "sxyFront_home",
        component: () =>
          import(/* webpackChunkName: "sxyFront_home" */ "../views/sales/saleStaff/sxyHome.vue"),
        meta: {
          title: '商学院-首页',
          keepAlive: true,
          breadList: ['销售', '商学院', '首页'],
        },
      },
      /* 商学院-前台-录音学习详情 */
      {
        path: "/sxyFront/sxyAudioLearnDetail",
        name: "sxyFront_sxyAudioLearnDetail",
        component: () =>
          import(/* webpackChunkName: "sxyAudioLearnDetail" */ "../views/sales/saleStaff/sxyAudioLearnDetail.vue"),
        meta: {
          title: '商学院-录音学习详情',
          breadList: ['销售', '商学院', '录音学习详情'],
        },
      },
      /* 商学院-前台-视频学习详情 */
      {
        path: "/sxyFront/sxyVideoLearnDetail",
        name: "sxyFront_sxyVideoLearnDetail",
        component: () =>
          import(/* webpackChunkName: "sxyVideoLearnDetail" */ "../views/sales/saleStaff/sxyVideoLearnDetail.vue"),
        meta: {
          title: '商学院-视频学习详情',
          breadList: ['销售', '商学院', '视频学习详情'],
        },
      },
      /* 商学院-前台-资料学习详情 */
      {
        path: "/sxyFront/sxyFileLearnDetail",
        name: "sxyFront_sxyFileLearnDetail",
        component: () =>
          import(/* webpackChunkName: "sxyFileLearnDetail" */ "../views/sales/saleStaff/sxyFileLearnDetail.vue"),
        meta: {
          title: '商学院-资料学习详情',
          breadList: ['销售', '商学院', '资料学习详情'],
        },
      },
      /* 商学院-前台-讨论中心详情 */
      {
        path: "/sxyFront/sxyDiscussionCenterDetail",
        name: "sxyFront_sxyDiscussionCenterDetail",
        component: () =>
          import(/* webpackChunkName: "sxyDiscussionCenterDetail" */ "../views/sales/saleStaff/sxyDiscussionCenterDetail.vue"),
        meta: {
          title: '商学院-讨论中心详情',
          breadList: ['销售', '商学院', '讨论中心详情'],
        },
      },
      /* 商学院-前台-升学政策详情 */
      {
        path: "/sxyFront/sxyNewsDetail",
        name: "sxyFront_sxyNewsDetail",
        component: () =>
          import(/* webpackChunkName: "sxyNewsDetail" */ "../views/sales/saleStaff/sxyNewsDetail.vue"),
        meta: {
          title: '商学院-升学政策详情',
          breadList: ['销售', '商学院', '升学政策详情'],
        },
      },
      /* 商学院-我的 */
      {
        path: "/sxyFront/my",
        name: "sxyFront_my",
        component: () =>
          import(/* webpackChunkName: "sxyFront_my" */ "../views/sales/saleStaff/sxyMy.vue"),
        meta: {
          title: '商学院-我的',
          keepAlive: true,
          breadList: ['销售', '商学院', '我的'],
        },
      },
      /* 销售 外呼审核员 */
      /* 外呼审核员 外呼数据审核 */
      {
        path: "/sales/saleAudit/useDataAudit",
        name: "saleAudit_useDataAudit",
        component: () =>
          import(/* webpackChunkName: "dataManage_useDataAudit" */ "../views/sales/dataManage/useDataAudit.vue"),
        meta: {
          title: '外呼数据审核',
          breadList: ['销售', '数据管理员', '外呼数据审核'],
        },
      },
      /* 外呼审核员 外呼数据审核详情 */
      {
        path: "/sales/saleAudit/useDataAuditDetail",
        name: "saleAudit_useDataAuditDetail",
        component: () =>
          import(/* webpackChunkName: "dataManage_useDataAuditDetail" */ "../views/sales/dataManage/useDataAuditDetail.vue"),
        meta: {
          title: '外呼数据审核详情',
          breadList: ['销售', '数据管理员', '外呼数据审核详情'],
          activeMenu: "/sales/saleAudit/useDataAudit"
        },
      },
      /* 销售专员 */
      {
        path: "/sales/saleStaff/dayPreview",
        name: "saleStaffPreview",
        component: () =>
          import(/* webpackChunkName: "saleStaffPreview" */ "../views/sales/saleStaff/dayPreview.vue"),
        meta: {
          title: '每日看板',
          keepAlive: true,
          breadList: ['销售', '销售专员', '每日看板'],
        },
      },
      {
        path: "/sales/saleStaff/dayPreviewV1",
        name: "saleStaff_dayPreviewV1",
        component: () =>
          import(/* webpackChunkName: "saleStaff_dayPreview" */ "../views/sales/saleStaff/dayPreviewV1.vue"),
        meta: {
          title: '每日看板V1',
          breadList: ['销售', '销售专员', '每日看板V1'],
        },
      },
      {
        path: "/sales/saleStaff/myPerformanceList",
        name: "saleStaff_myPerformanceList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_myPerformanceList" */ "../views/sales/saleStaff/myPerformanceList.vue"),
        meta: {
          title: '我的业绩',
          breadList: ['销售', '销售专员', '我的业绩'],
        },
      },
      {
        path: "/sales/saleStaff/handCallList",
        name: "saleStaff_handCallList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_handCallList" */ "../views/sales/saleStaff/handCallList.vue"),
        meta: {
          title: '拨打列表',
          breadList: ['销售', '销售专员', '拨打列表'],
        },
      },
      {
        path: "/sales/saleStaff/dataGetDetail",
        name: "saleStaff_dataGetDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_dataGetDetail" */ "../views/sales/saleStaff/dataGetDetail.vue"),
        meta: {
          title: '数据领取',
          breadList: ['销售', '销售专员', '数据领取'],
        },
      },
      {
        path: "/sales/saleStaff/callHistoryList",
        name: "saleStaff_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ['销售', '销售专员', '拨打记录'],
        },
      },
      // ai 录音分析
      {
        path: "/sales/saleStaff/aiAnalyseList",
        name: "saleStaff_aiAnalyseList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callHistoryList" */ "../views/sales/saleStaff/aiAnalyseList.vue"),
        meta: {
          title: '录音分析',
          keepAlive: true,
          breadList: ['销售', '销售专员', '录音分析'],
        },
      },
      // ai 录音分析详情
      {
        path: "/sales/saleStaff/aiAnalyseDetail",
        name: "saleStaff_aiAnalyseDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalyseDetail" */ "../views/sales/saleStaff/aiAnalyseDetail.vue"),
        meta: {
          title: '录音分析详情',
          activeMenu: "/sales/saleStaff/aiAnalyseList",
          breadList: ['销售', '销售专员', '录音分析详情'],
        },
      },
      // ai 分析14点分数
      {
        path: "/sales/saleStaff/aiAnalysePointDetail",
        name: "saleStaff_aiAnalysePointDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalysePointDetail" */ "../views/sales/saleStaff/aiAnalysePointDetail.vue"),
        meta: {
          title: '销售流程详细分析',
          activeMenu: "/sales/saleStaff/aiAnalyseList",
          breadList: ['销售', '销售专员', '销售流程详细分析'],
        },
      },
      {
        path: "/sales/saleStaff/workReport",
        name: "saleStaff_workReport",
        component: () =>
          import(/* webpackChunkName: "workReport" */ "../views/sales/saleStaff/workReport.vue"),
        meta: {
          title: '工作日报',
          breadList: ['销售', '销售专员', '工作日报'],
        },
      },
      {
        path: "/sales/saleStaff/parttimeCallHistoryList",
        name: "saleStaff_parttimeCallHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_parttimeCallHistoryList" */ "../views/sales/saleStaff/parttimeCallHistoryList.vue"),
        meta: {
          title: '兼职拨打记录',
          breadList: ['销售', '销售专员', '兼职拨打记录'],
        },
      },
      {
        path: "/sales/saleStaff/testPage",
        name: "saleStaff_testPage",
        component: () =>
          import(/* webpackChunkName: "saleStaff_testPage" */ "../views/sales/saleStaff/testPage.vue"),
        meta: {
          title: '测试页面',
          breadList: ['销售', '销售专员', '测试页面'],
        },
      },
      {
        path: "/sales/saleStaff/userList",
        name: "saleStaff_userList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_userList" */ "../views/sales/saleStaff/userList.vue"),
        meta: {
          title: '签约学生',
          breadList: ['销售', '销售专员', '签约学生'],
        },
      },
      {
        path: "/sales/saleStaff/parttimeIntention",
        name: "parttimeIntention",
        component: () =>
          import(/* webpackChunkName: "parttimeIntention" */ "../views/sales/saleStaff/parttimeIntention.vue"),
        meta: {
          title: '兼职意向',
          breadList: ['销售', '销售专员', '兼职意向'],
        },
      },
      {
        path: "/sales/saleStaff/parttimeStatistics",
        name: "parttimeStatistics",
        component: () =>
          import(/* webpackChunkName: "parttimeStatistics" */ "../views/sales/saleStaff/parttimeStatistics.vue"),
        meta: {
          title: '兼职统计',
          breadList: ['销售', '销售专员', '兼职统计'],
        },
      },
      {
        path: "/sales/saleStaff/orderList",
        name: "saleStaff_orderList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_orderList" */ "../views/sales/saleStaff/orderList.vue"),
        meta: {
          title: '订单列表',
          breadList: ['销售', '销售专员', '订单列表'],
        },
      },
      {
        path: "/sales/saleStaff/intentionList",
        name: "saleStaff_intentionList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_intentionList" */ "../views/sales/saleStaff/intentionList.vue"),
        meta: {
          title: '意向列表',
          breadList: ['销售', '销售专员', '意向列表'],
        },
      },
      /* ai意向列表 */
      {
        path: "/sales/saleStaff/aiIntentionList",
        name: "saleStaff_aiIntentionList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiIntentionList" */ "../views/sales/saleStaff/aiIntentionList.vue"),
        meta: {
          title: 'AI意向列表',
          breadList: ['销售', '销售专员', 'AI意向列表'],
        },
      },
      /* 销售专员 录音点评 */
      {
        path: "/sales/saleStaff/commentCallAudio",
        name: "staff_commentCallAudio",
        component: () =>
          import(/* webpackChunkName: "dataManage_commentCallAudio" */ "../views/sales/dataManage/commentCallAudio.vue"),
        meta: {
          title: '录音点评',
          keepAlive: true,
          breadList: ['销售', '销售专员', '录音点评'],
        },
      },
      {
        path: "/sales/saleStaff/callAudioStudy",
        name: "callAudioStudy",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callAudioStudy" */ "../views/sales/saleStaff/callAudioStudy.vue"),
        meta: {
          title: '录音学习',
          keepAlive: true,
          breadList: ['销售', '销售专员', '录音学习'],
        },
      },
      {
        path: "/sales/saleStaff/parttimeList",
        name: "saleStaff_parttimeList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_parttimeList" */ "../views/sales/saleStaff/parttimeList.vue"),
        meta: {
          title: '兼职列表',
          breadList: ['销售', '销售专员', '兼职列表'],
        },
      },
      {
        path: "/sales/saleStaff/publicUseList",
        name: "saleStaff_publicUseList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_publicUseList" */ "../views/sales/saleStaff/publicUseList.vue"),
        meta: {
          title: '公共兼职数据池',
          breadList: ['销售', '销售专员', '公共兼职数据池'],
        },
      },
      {
        path: "/sales/saleStaff/openSeaList",
        name: "saleStaff_openSeaList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_openSeaList" */ "../views/sales/saleStaff/openSeaList.vue"),
        meta: {
          title: '公海',
          breadList: ['销售', '销售专员', '公海'],
        },
      },
      /* 销售主管 */
      /* 销售组长-黑名单列表 */
      {
        path: "/sales/saleLeader/blackList",
        name: "leader_blackList",
        component: () =>
          import(/* webpackChunkName: "blackList" */ "../views/sales/dataManage/blackList.vue"),
        meta: {
          title: '销售组长',
          breadList: ['销售', '销售组长', '黑名单'],
        },
      },
      {
        path: "/sales/saleLeader/dayPreview",
        name: "saleLeader_preview",
        component: () =>
          import(/* webpackChunkName: "saleLeaderPreview" */ "../views/sales/saleLeader/dayPreview.vue"),
        meta: {
          title: '每日看板',
          keepAlive: true,
          breadList: ['销售', '销售主管', '每日看板'],
        },
      },
      {
        path: "/sales/saleLeader/dayPreviewV1",
        name: "saleLeader_dayPreviewV1",
        component: () =>
          import(/* webpackChunkName: "saleLeader_dayPreview" */ "../views/sales/saleLeader/dayPreviewV1.vue"),
        meta: {
          title: '每日看板V1',
          breadList: ['销售', '销售主管', '每日看板V1'],
        },
      },
      /* 销售主管-意向概览(意向列表) */
      {
        path: "/sales/saleLeader/intentionPreview",
        name: "saleLeader_intentionPreview",
        component: () =>
          import(/* webpackChunkName: "saleLeader_intentionPreview" */ "../views/sales/saleLeader/intentionPreview.vue"),
        meta: {
          title: '意向列表',
          breadList: ['销售', '销售主管', '意向列表'],
        },
      },
      {
        path: "/sales/saleLeader/intentionStatistics",
        name: "intentionStatistics",
        component: () =>
          import(/* webpackChunkName: "intentionStatistics" */ "../views/sales/saleLeader/intentionStatistics.vue"),
        meta: {
          title: '意向列表',
          breadList: ['销售', '销售主管', '意向列表'],
        },
      },
      {
        path: "/sales/saleLeader/orderStatistics",
        name: "orderStatistics",
        component: () =>
          import(/* webpackChunkName: "orderStatistics" */ "../views/sales/saleLeader/orderStatistics.vue"),
        meta: {
          title: '签约列表',
          breadList: ['销售', '销售主管', '签约列表'],
        },
      },
      {
        path: "/sales/saleLeader/saleStatistics",
        name: "saleStatistics",
        component: () =>
          import(/* webpackChunkName: "saleStatistics" */ "../views/sales/saleLeader/saleStatistics.vue"),
        meta: {
          title: '销售统计',
          breadList: ['销售', '销售主管', '销售统计'],
        },
      },
      {
        path: "/sales/saleLeader/weekReport",
        name: "saleLeader_dweekReport",
        component: () =>
          import(/* webpackChunkName: "saleLeader_weekReport" */ "../views/sales/saleLeader/weekReport.vue"),
        meta: {
          title: '本周报表',
          breadList: ['销售', '销售主管', '本周报表'],
        },
      },
      {
        path: "/sales/saleLeader/negotiationOrderList",
        name: "saleLeader_negotiationOrderList",
        component: () =>
          import(/* webpackChunkName: "saleLeader_negotiationOrderList" */ "../views/sales/saleLeader/negotiationOrderList.vue"),
        meta: {
          title: '谈单分析',
          breadList: ['销售', '销售主管', '谈单分析'],
        },
      },
      /* 销售主管 销售总监 外边多了一层 */
      {
        path: "/sales/saleLeader/callHistoryList",
        name: "saleLeader_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleLeader_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ['销售', '销售主管', '拨打记录'],
          //activeMenu: "/sales/saleLeader/callHistoryPreview"
        },
      },

      // ai 录音分析
      {
        path: "/sales/saleLeader/aiAnalyseList",
        name: "saleLeader_aiAnalyseList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callHistoryList" */ "../views/sales/saleStaff/aiAnalyseList.vue"),
        meta: {
          title: '录音分析',
          keepAlive: true,
          breadList: ['销售', '销售主管', '录音分析'],
        },
      },
      // ai 录音分析详情
      {
        path: "/sales/saleLeader/aiAnalyseDetail",
        name: "saleLeader_aiAnalyseDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalyseDetail" */ "../views/sales/saleStaff/aiAnalyseDetail.vue"),
        meta: {
          title: '录音分析详情',
          activeMenu: "/sales/saleLeader/aiAnalyseList",
          breadList: ['销售', '销售主管', '录音分析详情'],
        },
      },
      // ai 分析14点分数
      {
        path: "/sales/saleLeader/aiAnalysePointDetail",
        name: "saleLeader_aiAnalysePointDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalysePointDetail" */ "../views/sales/saleStaff/aiAnalysePointDetail.vue"),
        meta: {
          title: '销售流程详细分析',
          activeMenu: "/sales/saleLeader/aiAnalyseList",
          breadList: ['销售', '销售主管', '销售流程详细分析'],
        },
      },
      {
        path: "/sales/saleLeader/workReport",
        name: "saleLeader_workReport",
        component: () =>
          import(/* webpackChunkName: "workReport" */ "../views/sales/saleStaff/workReport.vue"),
        meta: {
          title: '工作日报',
          breadList: ['销售', '销售主管', '工作日报'],
        },
      },
      /* 销售主管 销售总监 多的拨打记录统计 */
      {
        path: "/sales/saleLeader/callHistoryPreview",
        name: "saleLeader_callHistoryPreview",
        component: () =>
          import(/* webpackChunkName: "saleLeader_callHistoryPreview" */ "../views/sales/saleMajordomo/callHistoryPreview.vue"),
        meta: {
          title: '拨打统计',
          breadList: ['销售', '销售主管', '拨打统计'],
        },
      },
      /* 销售主管 录音点评 */
      {
        path: "/sales/saleLeader/commentCallAudio",
        name: "leader_commentCallAudio",
        component: () =>
          import(/* webpackChunkName: "dataManage_commentCallAudio" */ "../views/sales/dataManage/commentCallAudio.vue"),
        meta: {
          title: '录音点评',
          keepAlive: true,
          breadList: ['销售', '销售主管', '录音点评'],
        },
      },
      /* 小组主管菜单 */
      /* 小组主管-意向列表 */
      {
        path: "/sales/groupManage/intentionStatistics",
        name: "groupManage_intentionStatistics",
        component: () =>
          import(/* webpackChunkName: "saleSectionIntertion" */ "../views/sales/saleLeader/intentionStatistics.vue"),
        meta: {
          title: '意向列表',
          breadList: ['销售', '销售主管', '意向列表'],
        },
      },
      /* 小组主管-部门意向 */
      {
        path: "/sales/groupManage/saleSectionIntertion",
        name: "saleSectionIntertion",
        component: () =>
          import(/* webpackChunkName: "saleSectionIntertion" */ "../views/sales/saleMajordomo/saleSectionIntertion.vue"),
        meta: {
          title: '部门意向',
          breadList: ['销售', '销售主管', '部门意向'],
        },
      },
      /* 小组主管-签约列表 */
      {
        path: "/sales/groupManage/orderStatistics",
        name: "groupManage_orderStatistics",
        component: () =>
          import(/* webpackChunkName: "orderStatistics" */ "../views/sales/saleLeader/orderStatistics.vue"),
        meta: {
          title: '签约列表',
          breadList: ['销售', '销售主管', '签约列表'],
        },
      },
      /* 小组主管-录音点评 */
      {
        path: "/sales/groupManage/commentCallAudio",
        name: "groupManage_commentCallAudio",
        component: () =>
          import(/* webpackChunkName: "dataManage_commentCallAudio" */ "../views/sales/dataManage/commentCallAudio.vue"),
        meta: {
          title: '录音点评',
          keepAlive: true,
          breadList: ['销售', '销售主管', '录音点评'],
        },
      },
      /* 小组主管-谈单分析 */
      {
        path: "/sales/groupManage/negotiationOrderList",
        name: "groupManage_negotiationOrderList",
        component: () =>
          import(/* webpackChunkName: "saleLeader_negotiationOrderList" */ "../views/sales/saleLeader/negotiationOrderList.vue"),
        meta: {
          title: '谈单分析',
          breadList: ['销售', '销售主管', '谈单分析'],
        },
      },
      /* 小组主管-每日看板 */
      {
        path: "/sales/groupManage/dayPreview",
        name: "groupManage_preview",
        component: () =>
          import(/* webpackChunkName: "saleLeaderPreview" */ "../views/sales/saleLeader/dayPreview.vue"),
        meta: {
          title: '每日看板',
          keepAlive: true,
          breadList: ['销售', '销售主管', '每日看板'],
        },
      },
      /* 小组主管-意向统计 */
      {
        path: "/sales/groupManage/intentionPreview",
        name: "groupManage_intentionPreview",
        component: () =>
          import(/* webpackChunkName: "saleLeader_intentionPreview" */ "../views/sales/saleLeader/intentionPreview.vue"),
        meta: {
          title: '意向统计',
          breadList: ['销售', '销售主管', '意向统计'],
        },
      },
      /* 小组主管-拨打统计 */
      {
        path: "/sales/groupManage/callHistoryPreview",
        name: "groupManage_callHistoryPreview",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleMajordomo/callHistoryPreview.vue"),
        meta: {
          title: '拨打统计',
          breadList: ['销售', '销售主管', '拨打统计'],
        },
      },
      {
        path: "/sales/groupManage/workReport",
        name: "groupManage_workReport",
        component: () =>
          import(/* webpackChunkName: "workReport" */ "../views/sales/saleStaff/workReport.vue"),
        meta: {
          title: '工作日报',
          breadList: ['销售', '销售主管', '工作日报'],
        },
      },
      /* 小组主管-拨打记录 */
      {
        path: "/sales/groupManage/callHistoryList",
        name: "groupManage_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ['销售', '销售主管', '拨打记录'],
          //activeMenu: "/sales/saleMajordomo/callHistoryPreview"
        },
      },
      // ai 录音分析
      {
        path: "/sales/groupManage/aiAnalyseList",
        name: "groupManage_aiAnalyseList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callHistoryList" */ "../views/sales/saleStaff/aiAnalyseList.vue"),
        meta: {
          title: '录音分析',
          keepAlive: true,
          breadList: ['销售', '销售主管', '录音分析'],
        },
      },
      // ai 录音分析详情
      {
        path: "/sales/groupManage/aiAnalyseDetail",
        name: "groupManage_aiAnalyseDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalyseDetail" */ "../views/sales/saleStaff/aiAnalyseDetail.vue"),
        meta: {
          title: '录音分析详情',
          activeMenu: "/sales/groupManage/aiAnalyseList",
          breadList: ['销售', '销售主管', '录音分析详情'],
        },
      },
      // ai 分析14点分数
      {
        path: "/sales/groupManage/aiAnalysePointDetail",
        name: "groupManage_aiAnalysePointDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalysePointDetail" */ "../views/sales/saleStaff/aiAnalysePointDetail.vue"),
        meta: {
          title: '销售流程详细分析',
          activeMenu: "/sales/groupManage/aiAnalyseList",
          breadList: ['销售', '销售主管', '销售流程详细分析'],
        },
      },
      /* 小组主管-销售个人库 */
      {
        path: "/sales/groupManage/salePersonalList",
        name: "groupManage_salePersonalList",
        component: () =>
          import(/* webpackChunkName: "dataManage_salePersonalList" */ "../views/sales/dataManage/salePersonalList.vue"),
        meta: {
          title: '销售个人库',
          breadList: ['销售', '销售主管', '销售个人库'],
        },
      },
      /* 小组主管-黑名单列表 */
      {
        path: "/sales/groupManage/blackList",
        name: "groupManage_blackList",
        component: () =>
          import(/* webpackChunkName: "blackList" */ "../views/sales/dataManage/blackList.vue"),
        meta: {
          title: '黑名单',
          breadList: ['销售', '销售主管', '黑名单'],
        },
      },
      /* 销售总监-黑名单列表 */
      {
        path: "/sales/saleMajordomo/blackList",
        name: "saleMajordomo_blackList",
        component: () =>
          import(/* webpackChunkName: "blackList" */ "../views/sales/dataManage/blackList.vue"),
        meta: {
          title: '黑名单',
          breadList: ['销售', '销售总监', '黑名单'],
        },
      },
      /* 销售总监-每日看板 */
      {
        path: "/sales/saleMajordomo/dayPreview",
        name: "saleMajordomo_preview",
        component: () =>
          import(/* webpackChunkName: "saleLeaderPreview" */ "../views/sales/saleLeader/dayPreview.vue"),
        meta: {
          title: '每日看板',
          keepAlive: true,
          breadList: ['销售', '销售总监', '每日看板'],
        },
      },
      {
        path: "/sales/saleMajordomo/dayPreviewV1",
        name: "saleMajordomo_dayPreviewV1",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_dayPreview" */ "../views/sales/saleLeader/dayPreviewV1.vue"),
        meta: {
          title: '每日看板V1',
          breadList: ['销售', '销售总监', '每日看板V1'],
        },
      },
      /* 销售主管-意向概览(意向列表) */
      {
        path: "/sales/saleMajordomo/intentionPreview",
        name: "saleMajordomo_intentionPreview",
        component: () =>
          import(/* webpackChunkName: "saleLeader_intentionPreview" */ "../views/sales/saleLeader/intentionPreview.vue"),
        meta: {
          title: '意向统计',
          breadList: ['销售', '销售总监', '意向统计'],
        },
      },
      {
        path: "/sales/saleLeader/salePersonalList",
        name: "saleLeader_salePersonalList",
        component: () =>
          import(/* webpackChunkName: "saleLeader_salePersonalList" */ "../views/sales/dataManage/salePersonalList.vue"),
        meta: {
          title: '销售个人库',
          breadList: ['销售', '销售主管', '销售个人库'],
        },
      },
      /* 我的兼职 */
      {
        path: "/sales/myParttime/dayPreview",
        name: "parttimePreview",
        component: () =>
          import(/* webpackChunkName: "myParttime_dayPreview" */ "../views/sales/myParttime/dayPreview.vue"),
        meta: {
          title: '今日看板',
          breadList: ['销售', '我的兼职', '今日看板'],
        },
      },
      {
        path: "/sales/myParttime/userList",
        name: "myParttime_userList",
        component: () =>
          import(/* webpackChunkName: "myParttime_userList" */ "../views/sales/myParttime/userList.vue"),
        meta: {
          title: '外呼列表',
          breadList: ['销售', '我的兼职', '外呼列表'],
        },
      },
      {
        path: "/sales/myParttime/intentionList",
        name: "myParttime_intentionList",
        component: () =>
          import(/* webpackChunkName: "myParttime_intentionList" */ "../views/sales/myParttime/intentionList.vue"),
        meta: {
          title: '意向表',
          breadList: ['销售', '我的兼职', '意向表'],
        },
      },
      {
        path: "/sales/myParttime/handCallList",
        name: "myParttime_handCallList",
        component: () =>
          import(/* webpackChunkName: "myParttime_handCallList" */ "../views/sales/myParttime/handCallList.vue"),
        meta: {
          title: '拨打列表',
          breadList: ['销售', '我的兼职', '拨打列表'],
        },
      },
      {
        path: "/sales/myParttime/dataGetDetail",
        name: "myParttime_dataGetDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_dataGetDetail" */ "../views/sales/saleStaff/dataGetDetail.vue"),
        meta: {
          title: '数据领取',
          breadList: ['销售', '我的兼职', '数据领取'],
        },
      },
      {
        path: "/sales/myParttime/callHistoryList",
        name: "myParttime_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "myParttime_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ['销售', '我的兼职', '拨打记录'],
        },
      },
      // ai 录音分析
      {
        path: "/sales/myParttime/aiAnalyseList",
        name: "myParttime_aiAnalyseList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callHistoryList" */ "../views/sales/saleStaff/aiAnalyseList.vue"),
        meta: {
          title: '录音分析',
          keepAlive: true,
          breadList: ['销售', '我的兼职', '录音分析'],
        },
      },
      // ai 录音分析详情
      {
        path: "/sales/myParttime/aiAnalyseDetail",
        name: "myParttime_aiAnalyseDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalyseDetail" */ "../views/sales/saleStaff/aiAnalyseDetail.vue"),
        meta: {
          title: '录音分析详情',
          activeMenu: "/sales/myParttime/aiAnalyseList",
          breadList: ['销售', '我的兼职', '录音分析详情'],
        },
      },
      // ai 分析14点分数
      {
        path: "/sales/myParttime/aiAnalysePointDetail",
        name: "myParttime_aiAnalysePointDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalysePointDetail" */ "../views/sales/saleStaff/aiAnalysePointDetail.vue"),
        meta: {
          title: '销售流程详细分析',
          activeMenu: "/sales/myParttime/aiAnalyseList",
          breadList: ['销售', '我的兼职', '销售流程详细分析'],
        },
      },
      {
        path: "/sales/myParttime/workReport",
        name: "myParttime_workReport",
        component: () =>
          import(/* webpackChunkName: "workReport" */ "../views/sales/saleStaff/workReport.vue"),
        meta: {
          title: '工作日报',
          breadList: ['销售', '我的兼职', '工作日报'],
        },
      },
      /* 数据管理员 */
      /* 商学院录音管理 */
      {
        path: "/sales/sxyAudioManage",
        name: "sxyAudioManage",
        component: () =>
          import(/* webpackChunkName: "sxyAudioManage" */ "../views/sales/dataManage/sxyAudioManage.vue"),
        meta: {
          title: '商学院-录音学习管理',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '商学院-录音学习管理'],
        },
      },
      /* 商学院视频管理 */
      {
        path: "/sales/sxyVideoManage",
        name: "sxyVideoManage",
        component: () =>
          import(/* webpackChunkName: "sxyVideoManage" */ "../views/sales/dataManage/sxyVideoManage.vue"),
        meta: {
          title: '商学院-视频学习管理',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '商学院-视频学习管理'],
        },
      },
      /* 商学院资料管理 */
      {
        path: "/sales/sxyMaterialManage",
        name: "sxyMaterialManage",
        component: () =>
          import(/* webpackChunkName: "sxyMaterialManage" */ "../views/sales/dataManage/sxyMaterialManage.vue"),
        meta: {
          title: '商学院-学习资料管理',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '商学院-学习资料管理'],
        },
      },
      /* 商学院讨论中心 */
      {
        path: "/sales/sxyDiscussionCenterManage",
        name: "sxyDiscussionCenterManage",
        component: () =>
          import(/* webpackChunkName: "sxyDiscussionCenterManage" */ "../views/sales/dataManage/sxyDiscussionCenterManage.vue"),
        meta: {
          title: '商学院-讨论中心管理',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '商学院-讨论中心管理'],
        },
      },
      /* 商学院资讯管理 */
      {
        path: "/sales/sxyNewsManage",
        name: "sxyNewsManage",
        component: () =>
          import(/* webpackChunkName: "sxyNewsManage" */ "../views/sales/dataManage/sxyNewsManage.vue"),
        meta: {
          title: '商学院-资讯管理',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '商学院-资讯管理'],
        },
      },
      {
        path: "/sales/dataManage/dataGetDetail",
        name: "dataManage_dataGetDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_dataGetDetail" */ "../views/sales/saleStaff/dataGetDetail.vue"),
        meta: {
          title: '数据领取',
          breadList: ['销售', '数据管理员', '数据领取'],
        },
      },
      /* 数据管理员 打卡统计 */
      {
        path: "/sales/dataManage/saleClockDetail",
        name: "saleClockDetail",
        component: () =>
          import(/* webpackChunkName: "saleClockDetail" */ "../views/sales/saleMajordomo/saleClockDetail.vue"),
        meta: {
          title: '打卡统计',
          breadList: ['销售', '数据管理员', '打卡统计'],
        },
      },
      /* 发送短信 */
      {
        path: "/sales/dataManage/sendMessageList",
        name: "sendMessageList",
        component: () =>
          import(/* webpackChunkName: "sendMessageList" */ "../views/sales/dataManage/sendMessageList.vue"),
        meta: {
          title: '发送短信',
          breadList: ['销售', '数据管理员', '发送短信'],
        },
      },
      /* 短信发送记录 */
      {
        path: "/sales/dataManage/sendMessageRecord",
        name: "sendMessageRecord",
        component: () =>
          import(/* webpackChunkName: "sendMessageList" */ "../views/sales/dataManage/sendMessageRecord.vue"),
        meta: {
          title: '短信记录',
          breadList: ['销售', '数据管理员', '短信记录'],
        },
      },
      /* 商圈管理 */
      {
        path: "/sales/dataManage/businessAreaList",
        name: "businessAreaList",
        component: () =>
          import(/* webpackChunkName: "businessAreaList" */ "../views/sales/dataManage/businessAreaList.vue"),
        meta: {
          title: '商圈管理',
          breadList: ['销售', '数据管理员', '商圈管理'],
        },
      },
      /* 检测数据管理 */
      {
        path: "/sales/dataManage/checkDataList",
        name: "checkDataList",
        component: () =>
          import(/* webpackChunkName: "checkDataList" */ "../views/sales/dataManage/checkDataList.vue"),
        meta: {
          title: '检测数据记录',
          breadList: ['销售', '数据管理员', '检测数据记录'],
        },
      },
      /* 销售打电话达标设置 */
      {
        path: "/sales/dataManage/callStandardSet",
        name: "callStandardSet",
        component: () =>
          import(/* webpackChunkName: "callStandardSet" */ "../views/sales/dataManage/callStandardSet.vue"),
        meta: {
          title: '达标设置',
          breadList: ['销售', '数据管理员', '达标设置'],
        },
      },
      /* 兼职打电话达标设置 */
      {
        path: "/sales/dataManage/parttimeCallStandardSet",
        name: "parttimeCallStandardSet",
        component: () =>
          import(/* webpackChunkName: "parttimeCallStandardSet" */ "../views/sales/dataManage/parttimeCallStandardSet.vue"),
        meta: {
          title: '公共兼职达标设置',
          breadList: ['销售', '数据管理员', '公共兼职达标设置'],
        },
      },
      /* 兼职今日看板 */
      {
        path: "/sales/dataManage/parttimeDayPreview",
        name: "dataManage_parttimePreview",
        component: () =>
          import(/* webpackChunkName: "myParttime_dayPreview" */ "../views/sales/myParttime/dayPreview.vue"),
        meta: {
          title: '公共兼职今日看板',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '公共兼职今日看板'],
        },
      },
      /* 快捷设置 */
      {
        path: "/sales/dataManage/quickSet",
        name: "quickSet",
        component: () =>
          import(/* webpackChunkName: "quickSet" */ "../views/sales/dataManage/quickSet.vue"),
        meta: {
          title: '快捷设置',
          breadList: ['销售', '数据管理员', '快捷设置'],
        },
      },
      /* 分配数据概览 */
      {
        path: "/sales/dataManage/allocDataPreivew",
        name: "allocDataPreivew",
        component: () =>
          import(/* webpackChunkName: "allocDataPreivew" */ "../views/sales/dataManage/allocDataPreivew.vue"),
        meta: {
          title: '分配数据概览',
          breadList: ['销售', '数据管理员', '分配数据概览'],
        },
      },
      /* 成功案例 */
      {
        path: "/sales/dataManage/successCaseList",
        name: "successCaseList",
        component: () =>
          import(/* webpackChunkName: "successCaseList" */ "../views/sales/dataManage/successCaseList.vue"),
        meta: {
          title: '成功案例',
          breadList: ['销售', '数据管理员', '成功案例'],
        },
      },
      /* 线下课摄像头管理 */
      {
        path: "/sales/dataManage/classCameraList",
        name: "classCameraList",
        component: () =>
          import(/* webpackChunkName: "classCameraList" */ "../views/sales/dataManage/classCameraList.vue"),
        meta: {
          title: '摄像头管理',
          breadList: ['销售', '数据管理员', '摄像头管理'],
        },
      },
      /* 沟通sop管理 */
      {
        path: "/sales/dataManage/sopList",
        name: "sopList",
        component: () =>
          import(/* webpackChunkName: "sopList" */ "../views/sales/dataManage/sopList.vue"),
        meta: {
          title: '沟通sop管理',
          breadList: ['销售', '数据管理员', '沟通sop管理'],
        },
      },
      /* 学校管理 */
      {
        path: "/sales/dataManage/schoolManage",
        name: "schoolManage",
        component: () =>
          import(/* webpackChunkName: "schoolManage" */ "../views/sales/dataManage/schoolManage.vue"),
        meta: {
          title: '学校管理',
          breadList: ['销售', '数据管理员', '学校管理'],
        },
      },
      /* 通知管理 */
      {
        path: "/sales/dataManage/noticeList",
        name: "noticeList",
        component: () =>
          import(/* webpackChunkName: "noticeList" */ "../views/sales/dataManage/noticeList.vue"),
        meta: {
          title: '通知管理',
          breadList: ['销售', '数据管理员', '通知管理'],
        },
      },
      {
        path: "/sales/dataManage/blackList",
        name: "dataManage_blackList",
        component: () =>
          import(/* webpackChunkName: "blackList" */ "../views/sales/dataManage/blackList.vue"),
        meta: {
          title: '黑名单',
          breadList: ['销售', '数据管理员', '黑名单'],
        },
      },
      {
        path: "/sales/dataManage/callLogList",
        name: "callLogList",
        component: () =>
          import(/* webpackChunkName: "callLogList" */ "../views/sales/dataManage/callLogList.vue"),
        meta: {
          title: '呼出记录',
          breadList: ['销售', '数据管理员', '呼出记录'],
        },
      },
      {
        path: "/sales/dataManage/callPool",
        name: "callPool",
        component: () =>
          import(/* webpackChunkName: "callPool" */ "../views/sales/dataManage/callPool.vue"),
        meta: {
          title: '总电话池',
          breadList: ['销售', '数据管理员', '总电话池'],
        },
      },
      {
        path: "/sales/dataManage/firstHandCallPool",
        name: "firstHandCallPool",
        component: () =>
          import(/* webpackChunkName: "firstHandCallPool" */ "../views/sales/dataManage/firstHandCallPool.vue"),
        meta: {
          title: '新数据池子',
          breadList: ['销售', '数据管理员', '新数据池子'],
        },
      },
      {
        path: "/sales/dataManage/successHandCallPool",
        name: "successHandCallPool",
        component: () =>
          import(/* webpackChunkName: "successHandCallPool" */ "../views/sales/dataManage/successHandCallPool.vue"),
        meta: {
          title: '真实数据池子',
          breadList: ['销售', '数据管理员', '真实数据池子'],
        },
      },
      {
        path: "/sales/dataManage/rubbishList",
        name: "rubbishList",
        component: () =>
          import(/* webpackChunkName: "rubbishList" */ "../views/sales/dataManage/rubbishList.vue"),
        meta: {
          title: '垃圾库',
          breadList: ['销售', '数据管理员', '垃圾库'],
        },
      },
      {
        path: "/sales/dataManage/noWanderList",
        name: "noWanderList",
        component: () =>
          import(/* webpackChunkName: "noWanderList" */ "../views/sales/dataManage/noWanderList.vue"),
        meta: {
          title: '禁止轮转列表',
          breadList: ['销售', '数据管理员', '禁止轮转列表'],
        },
      },
      {
        path: "/sales/dataManage/upgradationList",
        name: "upgradationList",
        component: () =>
          import(/* webpackChunkName: "upgradationList" */ "../views/sales/dataManage/upgradationList.vue"),
        meta: {
          title: '升级学生列表',
          breadList: ['销售', '数据管理员', '升级学生列表'],
        },
      },
      {
        path: "/sales/dataManage/openSeaList",
        name: "dataManage_openSeaList",
        component: () =>
          import(/* webpackChunkName: "dataManage_openSeaList" */ "../views/sales/dataManage/openSeaList.vue"),
        meta: {
          title: '公海',
          breadList: ['销售', '数据管理员', '公海'],
        },
      },
      /* 数据管理员 外呼数据审核 */
      {
        path: "/sales/dataManage/useDataAudit",
        name: "dataManage_useDataAudit",
        component: () =>
          import(/* webpackChunkName: "dataManage_useDataAudit" */ "../views/sales/dataManage/useDataAudit.vue"),
        meta: {
          title: '外呼数据审核',
          breadList: ['销售', '数据管理员', '外呼数据审核'],
        },
      },
      /* 数据管理员 外呼数据审核详情 */
      {
        path: "/sales/dataManage/useDataAuditDetail",
        name: "dataManage_useDataAuditDetail",
        component: () =>
          import(/* webpackChunkName: "dataManage_useDataAuditDetail" */ "../views/sales/dataManage/useDataAuditDetail.vue"),
        meta: {
          title: '外呼数据审核详情',
          breadList: ['销售', '数据管理员', '外呼数据审核详情'],
          activeMenu: "/sales/dataManage/useDataAudit"
        },
      },
      {
        path: "/sales/dataManage/publicUseList",
        name: "dataManage_publicUseList",
        component: () =>
          import(/* webpackChunkName: "dataManage_publicUseList" */ "../views/sales/dataManage/publicUseList.vue"),
        meta: {
          title: '公共兼职数据池',
          breadList: ['销售', '数据管理员', '公共兼职数据池'],
        },
      },
      {
        path: "/sales/dataManage/importListStatistics",
        name: "importListStatistics",
        component: () =>
          import(/* webpackChunkName: "importListStatistics" */ "../views/sales/dataManage/importListStatistics.vue"),
        meta: {
          title: '数据统计',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '数据统计'],
        },
      },
      {
        path: "/sales/dataManage/importBatchAlloc",
        name: "importBatchAlloc",
        component: () =>
          import(/* webpackChunkName: "importBatchAlloc" */ "../views/sales/dataManage/importBatchAlloc.vue"),
        meta: {
          title: '数据分配',
          activeMenu: '/sales/dataManage/importListStatistics',
          breadList: ['销售', '数据管理员', '数据分配'],
        },
      },
      /* 公共兼职拨打记录 */
      {
        path: "/sales/dataManage/parttimeCallHistoryList",
        name: "dataManage_parttime_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '公共兼职拨打记录',
          breadList: ['销售', '数据管理员', '公共兼职拨打记录'],
          //activeMenu: "/sales/saleMajordomo/callHistoryPreview"
        },
      },
      /* 数据管理员 公共兼职拨打统计 */
      {
        path: "/sales/dataManage/parttimeCallHistoryPreview",
        name: "dataManage_parttime_callHistoryPreview",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleMajordomo/callHistoryPreview.vue"),
        meta: {
          title: '公共兼职拨打统计',
          breadList: ['销售', '数据管理员', '公共兼职拨打统计'],
        },
      },
      {
        path: "/sales/dataManage/workReport",
        name: "dataManage_workReport",
        component: () =>
          import(/* webpackChunkName: "workReport" */ "../views/sales/saleStaff/workReport.vue"),
        meta: {
          title: '工作日报',
          breadList: ['销售', '数据管理员', '工作日报'],
        },
      },
      /* 数据管理员 外边多了一层 */
      {
        path: "/sales/dataManage/callHistoryList",
        name: "dataManage_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ['销售', '数据管理员', '拨打记录'],
          //activeMenu: "/sales/saleMajordomo/callHistoryPreview"
        },
      },
      // ai 录音分析
      {
        path: "/sales/dataManage/aiAnalyseList",
        name: "dataManage_aiAnalyseList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callHistoryList" */ "../views/sales/saleStaff/aiAnalyseList.vue"),
        meta: {
          title: '录音分析',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '录音分析'],
        },
      },
      // ai 录音分析详情
      {
        path: "/sales/dataManage/aiAnalyseDetail",
        name: "dataManage_aiAnalyseDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalyseDetail" */ "../views/sales/saleStaff/aiAnalyseDetail.vue"),
        meta: {
          title: '录音分析详情',
          activeMenu: "/sales/dataManage/aiAnalyseList",
          breadList: ['销售', '数据管理员', '录音分析详情'],
        },
      },
      // ai 分析14点分数
      {
        path: "/sales/dataManage/aiAnalysePointDetail",
        name: "dataManage_aiAnalysePointDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalysePointDetail" */ "../views/sales/saleStaff/aiAnalysePointDetail.vue"),
        meta: {
          title: '销售流程详细分析',
          activeMenu: "/sales/dataManage/aiAnalyseList",
          breadList: ['销售', '数据管理员', '销售流程详细分析'],
        },
      },
      /* 数据管理员 多的拨打记录统计 */
      {
        path: "/sales/dataManage/callHistoryPreview",
        name: "dataManage_callHistoryPreview",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleMajordomo/callHistoryPreview.vue"),
        meta: {
          title: '拨打统计',
          breadList: ['销售', '数据管理员', '拨打统计'],
        },
      },
      /* 数据管理员 录音点评 */
      {
        path: "/sales/dataManage/commentCallAudio",
        name: "dataManage_commentCallAudio",
        component: () =>
          import(/* webpackChunkName: "dataManage_commentCallAudio" */ "../views/sales/dataManage/commentCallAudio.vue"),
        meta: {
          title: '录音点评',
          keepAlive: true,
          breadList: ['销售', '数据管理员', '录音点评'],
        },
      },
      // 录音点评详情
      {
        path: "/sales/dataManage/audioCommentDetail",
        name: "dataManage_audioCommentDetail",
        component: () =>
          import(/* webpackChunkName: "dataManage_audioCommentDetail" */ "../views/sales/dataManage/audioCommentDetail.vue"),
        meta: {
          title: '录音点评',
          breadList: ['销售', '数据管理员', '录音点评'],
        },
      },
      {
        path: "/sales/dataManage/otherSourceList",
        name: "dataManage_otherSourceList",
        component: () =>
          import(/* webpackChunkName: "dataManage_otherSourceList" */ "../views/sales/dataManage/otherSourceList.vue"),
        meta: {
          title: '其他来源',
          breadList: ['销售', '数据管理员', '其他来源'],
        },
      },
      {
        path: "/sales/dataManage/otherSourceAlloc",
        name: "dataManage_otherSourceAlloc",
        component: () =>
          import(/* webpackChunkName: "dataManage_otherSourceAlloc" */ "../views/sales/dataManage/otherSourceAlloc.vue"),
        meta: {
          title: '重复数据',
          activeMenu: '/sales/dataManage/otherSourceList',
          breadList: ['销售', '数据管理员', '重复数据'],
        },
      },
      {
        path: "/sales/dataManage/otherSourceDetail",
        name: "dataManage_otherSourceDetail",
        component: () =>
          import(/* webpackChunkName: "dataManage_otherSourceDetail" */ "../views/sales/dataManage/otherSourceDetail.vue"),
        meta: {
          title: '其他来源详情',
          activeMenu: '/sales/dataManage/otherSourceList',
          breadList: ['销售', '数据管理员', '其他来源详情'],
        },
      },
      {
        path: "/sales/dataManage/importList",
        name: "dataManage_importList",
        component: () =>
          import(/* webpackChunkName: "dataManage_importList" */ "../views/sales/dataManage/importList.vue"),
        meta: {
          title: '数据列表',
          breadList: ['销售', '数据管理员', '数据列表'],
        },
      },
      {
        path: "/sales/dataManage/importList/importDetail",
        name: "importDetail",
        component: () =>
          import(/* webpackChunkName: "importDetail" */ "../views/sales/dataManage/importDetail.vue"),
        meta: {
          title: '数据详情',
          activeMenu: '/sales/dataManage/importList',
          breadList: ['销售', '数据管理员', '数据列表', '数据详情'],
        },
      },
      {
        path: "/sales/dataManage/callTaskList",
        name: "dataManage_callTaskList",
        component: () =>
          import(/* webpackChunkName: "dataManage_callTaskList" */ "../views/sales/dataManage/callTaskList.vue"),
        meta: {
          title: '任务列表',
          breadList: ['销售', '数据管理员', '任务列表'],
        },
      },
      {
        path: "/sales/dataManage/phoneBind",
        name: "dataManage_phoneBind",
        component: () =>
          import(/* webpackChunkName: "dataManage_phoneBind" */ "../views/sales/dataManage/phoneBind.vue"),
        meta: {
          title: '手机号绑定',
          breadList: ['销售', '数据管理员', '手机号绑定'],
        },
      },
      {
        path: "/sales/dataManage/callMonitor",
        name: "dataManage_callMonitor",
        component: () =>
          import(/* webpackChunkName: "dataManage_callMonitor" */ "../views/sales/dataManage/callMonitor.vue"),
        meta: {
          title: '坐席监控',
          breadList: ['销售', '数据管理员', '坐席监控'],
        },
      },
      {
        path: "/sales/dataManage/callAccountManage",
        name: "dataManage_callAccountManage",
        component: () =>
          import(/* webpackChunkName: "dataManage_callAccountManage" */ "../views/sales/dataManage/callAccountManage.vue"),
        meta: {
          title: '坐席分配',
          breadList: ['销售', '数据管理员', '坐席分配'],
        },
      },
      {
        path: "/sales/dataManage/callPlatformSet",
        name: "dataManage_callPlatformSet",
        component: () =>
          import(/* webpackChunkName: "dataManage_callPlatformSet" */ "../views/sales/dataManage/callPlatformSet.vue"),
        meta: {
          title: '电话设置',
          breadList: ['销售', '数据管理员', '电话设置'],
        },
      },

      {
        path: "/sales/dataManage/sectionCallTransforSetList",
        name: "sectionCallTransforSetList",
        component: () =>
          import(/* webpackChunkName: "sectionCallTransforSetList" */ "../views/sales/dataManage/sectionCallTransforSetList.vue"),
        meta: {
          title: '部门转接设置',
          breadList: ['销售', '数据管理员', '部门转接设置'],
        },
      },
      {
        path: "/ai/bwFileDataBase",
        name: "bwFileDataBase",
        component: () =>
          import(/* webpackChunkName: "bwFileDataBase" */ "../views/ai/bwFileDataBase.vue"),
        meta: {
          title: '北文知识库',
          breadList: ['北文资料库', '北文知识库'],
        },
      },
      {
        path: "/ai/fileToQaPair",
        name: "fileToQaPair",
        component: () =>
          import(/* webpackChunkName: "fileToQaPair" */ "../views/ai/fileToQaPair.vue"),
        meta: {
          title: '解析问答对',
          breadList: ['北文资料库', '解析问答对'],
        },
      },
      {
        path: "/ai/qaPairList",
        name: "qaPairList",
        component: () =>
          import(/* webpackChunkName: "qaPairList" */ "../views/ai/qaPairList.vue"),
        meta: {
          title: '问答对库',
          breadList: ['北文资料库', '问答对库'],
        },
      },
      {
        path: "/ai/localRepoList",
        name: "localRepoList",
        component: () =>
          import(/* webpackChunkName: "localRepoList" */ "../views/ai/localRepoList.vue"),
        meta: {
          title: '北文知识库',
          breadList: ['北文资料库', '北文知识库'],
        },
      },
      {
        path: "/ai/localRepoMyDetail",
        name: "localRepoMyDetail",
        component: () =>
          import(/* webpackChunkName: "localRepoAudit" */ "../views/ai/localRepoAudit.vue"),
        meta: {
          title: '上传资料',
          breadList: ['北文资料库', '上传资料'],
        },
      },
      {
        path: "/ai/localRepoAudit",
        name: "localRepoAudit",
        component: () =>
          import(/* webpackChunkName: "localRepoAudit" */ "../views/ai/localRepoAudit.vue"),
        meta: {
          title: '上传/审核资料',
          breadList: ['北文资料库', '上传/审核资料'],
        },
      },
      {
        path: "/ai/aiRepoList",
        name: "aiRepoList",
        component: () =>
          import(/* webpackChunkName: "aiRepoList" */ "../views/ai/aiRepoList.vue"),
        meta: {
          title: 'ai知识库',
          breadList: ['北文资料库', 'ai知识库'],
        },
      },
      {
        path: "/sales/dataManage/salePersonalList",
        name: "dataManage_salePersonalList",
        component: () =>
          import(/* webpackChunkName: "dataManage_salePersonalList" */ "../views/sales/dataManage/salePersonalList.vue"),
        meta: {
          title: '销售个人库',
          breadList: ['销售', '数据管理员', '销售个人库'],
        },
      },
      {
        path: "/sales/dataManage/biYeShengList",
        name: "dataManage_biYeShengList",
        component: () =>
          import(/* webpackChunkName: "dataManage_biYeShengList" */ "../views/sales/dataManage/biYeShengList.vue"),
        meta: {
          title: '毕业生列表',
          breadList: ['销售', '数据管理员', '毕业生列表'],
        },
      },
      {
        path: "/sales/dataManage/callTaskList/callTaskDetail",
        name: "callDetail",
        component: () =>
          import(/* webpackChunkName: "callDetail" */ "../views/sales/dataManage/callTaskDetail.vue"),
        meta: {
          title: '任务详情',
          activeMenu: '/sales/dataManage/callTaskList',
          breadList: ['销售', '数据管理员', '任务列表', '任务详情'],
        },
      },
      /* 销售总监 */
      {
        path: "/sales/saleMajordomo/orderStatistics",
        name: "major_orderStatistics",
        component: () =>
          import(/* webpackChunkName: "orderStatistics" */ "../views/sales/saleLeader/orderStatistics.vue"),
        meta: {
          title: '签约列表',
          breadList: ['销售', '销售总监', '签约列表'],
        },
      },
      /* 销售总监 打卡统计 */
      {
        path: "/sales/saleMajordomo/saleClockDetail",
        name: "saleMajordomo_saleClockDetail",
        component: () =>
          import(/* webpackChunkName: "saleClockDetail" */ "../views/sales/saleMajordomo/saleClockDetail.vue"),
        meta: {
          title: '打卡统计',
          breadList: ['销售', '销售总监', '打卡统计'],
        },
      },
      {
        path: "/sales/saleMajordomo/intentionStatistics",
        name: "major_intentionStatistics",
        component: () =>
          import(/* webpackChunkName: "saleSectionIntertion" */ "../views/sales/saleLeader/intentionStatistics.vue"),
        meta: {
          title: '意向列表',
          breadList: ['销售', '销售总监', '意向列表'],
        },
      },
      {
        path: "/sales/saleMajordomo/saleSectionIntertion",
        name: "saleMajordomo_saleSectionIntertion",
        component: () =>
          import(/* webpackChunkName: "saleSectionIntertion" */ "../views/sales/saleMajordomo/saleSectionIntertion.vue"),
        meta: {
          title: '部门意向',
          breadList: ['销售', '销售总监', '部门意向'],
        },
      },
      {
        path: "/sales/saleMajordomo/saleStaffPerformanceSet",
        name: "saleStaffPerformanceSet",
        component: () =>
          import(/* webpackChunkName: "saleStaffPerformanceSet" */ "../views/sales/saleMajordomo/saleStaffPerformanceSet.vue"),
        meta: {
          title: '员工业绩设置',
          breadList: ['销售', '销售总监', '员工业绩设置'],
        },
      },
      /* 销售总监谈单分析 */
      {
        path: "/sales/saleMajordomo/negotiationOrderList",
        name: "saleMajordomo_negotiationOrderList",
        component: () =>
          import(/* webpackChunkName: "saleLeader_negotiationOrderList" */ "../views/sales/saleLeader/negotiationOrderList.vue"),
        meta: {
          title: '谈单分析',
          breadList: ['销售', '销售总监', '谈单分析'],
        },
      },
      /* 公共兼职拨打记录 */
      {
        path: "/sales/saleMajordomo/parttimeCallHistoryList",
        name: "saleMajordomo_parttime_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '公共兼职拨打记录',
          breadList: ['销售', '销售总监', '公共兼职拨打记录'],
        },
      },
      /* 销售总监 外呼数据审核 */
      {
        path: "/sales/saleMajordomo/useDataAudit",
        name: "saleMajordomo_useDataAudit",
        component: () =>
          import(/* webpackChunkName: "dataManage_useDataAudit" */ "../views/sales/dataManage/useDataAudit.vue"),
        meta: {
          title: '外呼数据审核',
          breadList: ['销售', '销售总监', '外呼数据审核'],
        },
      },
      /* 销售总监 外呼数据审核详情 */
      {
        path: "/sales/saleMajordomo/useDataAuditDetail",
        name: "saleMajordomo_useDataAuditDetail",
        component: () =>
          import(/* webpackChunkName: "dataManage_useDataAuditDetail" */ "../views/sales/dataManage/useDataAuditDetail.vue"),
        meta: {
          title: '外呼数据审核详情',
          breadList: ['销售', '数据管理员', '外呼数据审核详情'],
          activeMenu: "/sales/saleMajordomo/useDataAudit"
        },
      },
      /* 销售总监 兼职今日看板 */
      {
        path: "/sales/saleMajordomo/parttimeDayPreview",
        name: "saleMajordomo_parttimePreview",
        component: () =>
          import(/* webpackChunkName: "myParttime_dayPreview" */ "../views/sales/myParttime/dayPreview.vue"),
        meta: {
          title: '公共兼职今日看板',
          keepAlive: true,
          breadList: ['销售', '销售总监', '公共兼职今日看板'],
        },
      },
      /* 销售总监 公共兼职拨打统计 */
      {
        path: "/sales/saleMajordomo/parttimeCallHistoryPreview",
        name: "saleMajordomo_parttime_callHistoryPreview",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleMajordomo/callHistoryPreview.vue"),
        meta: {
          title: '公共兼职拨打统计',
          breadList: ['销售', '销售总监', '公共兼职拨打统计'],
        },
      },
      {
        path: "/sales/saleMajordomo/workReport",
        name: "saleMajordomo_workReport",
        component: () =>
          import(/* webpackChunkName: "workReport" */ "../views/sales/saleStaff/workReport.vue"),
        meta: {
          title: '工作日报',
          breadList: ['销售', '销售总监', '工作日报'],
        },
      },
      /* 销售主管 销售总监 外边多了一层 */
      {
        path: "/sales/saleMajordomo/callHistoryList",
        name: "saleMajordomo_callHistoryList",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleStaff/callHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ['销售', '销售总监', '拨打记录'],
          //activeMenu: "/sales/saleMajordomo/callHistoryPreview"
        },
      },
      // ai 录音分析
      {
        path: "/sales/saleMajordomo/aiAnalyseList",
        name: "saleMajordomo_aiAnalyseList",
        component: () =>
          import(/* webpackChunkName: "saleStaff_callHistoryList" */ "../views/sales/saleStaff/aiAnalyseList.vue"),
        meta: {
          title: '录音分析',
          keepAlive: true,
          breadList: ['销售', '销售总监', '录音分析'],
        },
      },
      // ai 录音分析详情
      {
        path: "/sales/saleMajordomo/aiAnalyseDetail",
        name: "saleMajordomo_aiAnalyseDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalyseDetail" */ "../views/sales/saleStaff/aiAnalyseDetail.vue"),
        meta: {
          title: '录音分析详情',
          activeMenu: "/sales/saleMajordomo/aiAnalyseList",
          breadList: ['销售', '销售总监', '录音分析详情'],
        },
      },
      // ai 分析14点分数
      {
        path: "/sales/saleMajordomo/aiAnalysePointDetail",
        name: "saleMajordomo_aiAnalysePointDetail",
        component: () =>
          import(/* webpackChunkName: "saleStaff_aiAnalysePointDetail" */ "../views/sales/saleStaff/aiAnalysePointDetail.vue"),
        meta: {
          title: '销售流程详细分析',
          activeMenu: "/sales/saleMajordomo/aiAnalyseList",
          breadList: ['销售', '销售总监', '销售流程详细分析'],
        },
      },
      /* 销售主管 销售总监 多的拨打记录统计 */
      {
        path: "/sales/saleMajordomo/callHistoryPreview",
        name: "saleMajordomo_callHistoryPreview",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_callHistoryList" */ "../views/sales/saleMajordomo/callHistoryPreview.vue"),
        meta: {
          title: '拨打统计',
          breadList: ['销售', '销售总监', '拨打统计'],
        },
      },
      /* 销售总监 录音点评 */
      {
        path: "/sales/saleMajordomo/commentCallAudio",
        name: "saleMagordomo_commentCallAudio",
        component: () =>
          import(/* webpackChunkName: "dataManage_commentCallAudio" */ "../views/sales/dataManage/commentCallAudio.vue"),
        meta: {
          title: '录音点评',
          keepAlive: true,
          breadList: ['销售', '销售总监', '录音点评'],
        },
      },
      {
        path: "/sales/saleMajordomo/salePersonalList",
        name: "saleMajordomo_salePersonalList",
        component: () =>
          import(/* webpackChunkName: "saleMajordomo_salePersonalList" */ "../views/sales/dataManage/salePersonalList.vue"),
        meta: {
          title: '销售个人库',
          breadList: ['销售', '销售总监', '销售个人库'],
        },
      },
      /* 财务 */
      {
        path: "/finance/dayPreview",
        name: "finance_dayPreview",
        component: () =>
          import(/* webpackChunkName: "finance_dayPreview" */ "../views/finance/dayPreview.vue"),
        meta: {
          title: '每日看板',
          breadList: ['财务', '每日看板'],
        },
      },
      {
        path: "/finance/classConsumeStatistics",
        name: "finance_classConsumeStatistics",
        component: () =>
          import(/* webpackChunkName: "finance_classConsumeStatistics" */ "../views/finance/classConsumeStatistics.vue"),
        meta: {
          title: '课酬课耗统计',
          breadList: ['财务', '课酬课耗统计'],
        },
      },
      {
        path: "/finance/orderList",
        name: "finance_orderList",
        component: () =>
          import(/* webpackChunkName: "finance_orderList" */ "../views/finance/orderList.vue"),
        meta: {
          title: '订单审核',
          breadList: ['财务', '订单审核'],
        },
      },
      {
        path: "/finance/incomeStatistics",
        name: "finance_incomeStatistics",
        component: () =>
          import(/* webpackChunkName: "finance_incomeStatistics" */ "../views/finance/incomeStatistics.vue"),
        meta: {
          title: '收入统计',
          breadList: ['财务', '收入统计'],
        },
      },
      {
        path: "/finance/classhourStatistics",
        name: "finance_classhourStatistics",
        component: () =>
          import(/* webpackChunkName: "finance_classhourStatistics" */ "../views/finance/classhourStatistics.vue"),
        meta: {
          title: '课时统计',
          breadList: ['财务', '课时统计'],
        },
      },
      {
        path: "/finance/refundList",
        name: "finance_refundList",
        component: () =>
          import(/* webpackChunkName: "finance_refundList" */ "../views/finance/refundList.vue"),
        meta: {
          title: '退款明细',
          breadList: ['财务', '退款明细'],
        },
      },
      {
        path: "/finance/teacherWageList",
        name: "finance_teacherWageList",
        component: () =>
          import(/* webpackChunkName: "finance_teacherWageList" */ "../views/finance/teacherWageList.vue"),
        meta: {
          title: '讲师课酬',
          breadList: ['财务', '讲师课酬'],
        },
      },
      {
        path: "/finance/studentClasshour",
        name: "finance_studentClasshour",
        component: () =>
          import(/* webpackChunkName: "finance_studentClasshour" */ "../views/finance/studentClasshour.vue"),
        meta: {
          title: '学员课时',
          breadList: ['财务', '学员课时'],
        },
      },
      {
        path: "/finance/classPayList",
        name: "finance_classPayList",
        component: () =>
          import(/* webpackChunkName: "finance_classPayList" */ "../views/finance/classPayList.vue"),
        meta: {
          title: '课酬设置',
          breadList: ['财务', '课酬设置'],
        },
      },
      {
        path: "/finance/studentNoClassList",
        name: "finance_studentNoClassList",
        component: () =>
          import(/* webpackChunkName: "finance_studentNoClassList" */ "../views/finance/studentNoClassList.vue"),
        meta: {
          title: '未上课学生',
          breadList: ['财务', '未上课学生'],
        },
      },
      {
        path: "/finance/salePerformanceList",
        name: "finance_salePerformanceList",
        component: () =>
          import(/* webpackChunkName: "finance_salePerformanceList" */ "../views/finance/salePerformanceList.vue"),
        meta: {
          title: '销售业绩',
          breadList: ['财务', '销售业绩'],
        },
      },

      {
        path: "/finance/teachBusinessPerformanceList",
        name: "finance_teachBusinessPerformanceList",
        component: () =>
          import(/* webpackChunkName: "finance_teachBusinessPerformanceList" */ "../views/finance/teachBusinessPerformanceList.vue"),
        meta: {
          title: '教务业绩',
          breadList: ['财务', '教务业绩'],
        },
      },
      {
        path: "/finance/studentPackageList",
        name: "finance_studentPackageList",
        component: () =>
          import(/* webpackChunkName: "finance_studentPackageList" */ "../views/finance/studentPackageList.vue"),
        meta: {
          title: '学员套餐',
          breadList: ['财务', '学员套餐'],
        },
      },
      {
        path: "/finance/remainClasshourList",
        name: "finance_remainClasshourList",
        component: () =>
          import(/* webpackChunkName: "finance_remainClasshourList" */ "../views/finance/remainClasshourList.vue"),
        meta: {
          title: '剩余课时',
          breadList: ['财务', '剩余课时'],
        },
      },
      /* 教务 */
      /* 教务专员 */
      {
        path: "/teachBusiness/teachBusinessAttache/dayPreview",
        name: "teachBusinessAttache_dayPreview",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_dayPreview" */ "../views/teachBusiness/teachBusinessAttache/dayPreview.vue"),
        meta: {
          title: '每日看板',
          breadList: ['教务', '教务专员', '每日看板'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/dayPreviewDetail",
        name: "teachBusinessAttache_dayPreviewDetail",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_dayPreviewDetail" */ "../views/teachBusiness/teachBusinessAttache/dayPreviewDetail.vue"),
        meta: {
          title: '每日看板',
          activeMenu: '/teachBusiness/teachBusinessAttache/dayPreview',
          breadList: ['教务', '教务专员', '每日看板', "看板信息"],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/myIncome",
        name: "teachBusinessAttache_myIncome",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_myIncome" */ "../views/teachBusiness/teachBusinessAttache/myIncome.vue"),
        meta: {
          title: '我的收入',
          breadList: ['教务', '教务专员', '我的收入'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/addStudent",
        name: "teachBusinessAttache_addStudent",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_addStudent" */ "../views/teachBusiness/teachBusinessAttache/addStudent.vue"),
        meta: {
          title: '新增学员',
          breadList: ['教务', '教务专员', '新增学员'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/myStudentList",
        name: "teachBusinessAttache_myStudentList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_myStudentList" */ "../views/teachBusiness/teachBusinessAttache/myStudentList.vue"),
        meta: {
          title: '我的学员',
          breadList: ['教务', '教务专员', '我的学员'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/studentSubjectInfo",
        name: "teachBusinessAttache_studentSubjectInfo",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_studentSubjectInfo" */ "../views/teachBusiness/teachBusinessAttache/studentSubjectInfo.vue"),
        meta: {
          title: '学员科目',
          breadList: ['教务', '教务专员', '学员科目'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/courseList",
        name: "teachBusinessAttache_courseList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_courseList" */ "../views/teachBusiness/teachBusinessAttache/courseList.vue"),
        meta: {
          title: '课表管理',
          breadList: ['教务', '教务专员', '课表管理'],
        },
      },
      {
        path: "/teachBusiness/courseReportDetail",
        name: "teachBusiness_courseReportDetail",
        component: () =>
          import(/* webpackChunkName: "teachBusiness_courseReportDetail" */ "../views/teachBusiness/teachBusinessAttache/courseReportDetail.vue"),
        meta: {
          title: '报告详情',
          breadList: ['教务', '教务专员', '报告详情'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/monitorClass",
        name: "teachBusinessAttache_monitorClass",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_monitorClass" */ "../views/teachBusiness/teachBusinessAttache/monitorClass.vue"),
        meta: {
          title: '监课管理',
          breadList: ['教务', '教务专员', '监课管理'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/playbackList",
        name: "teachBusinessAttache_playbackList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_playbackList" */ "../views/teachBusiness/teachBusinessAttache/playbackList.vue"),
        meta: {
          title: '回放管理',
          breadList: ['教务', '教务专员', '回放管理'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/classPayList",
        name: "teachBusinessAttache_classPayList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_classPayList" */ "../views/finance/classPayList.vue"),
        meta: {
          title: '课酬设置',
          breadList: ['教务', '教务专员', '课酬设置'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/teacherListFormal",
        name: "teachBusinessAttache_teacherListFormal",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_teacherListFormal" */ "../views/teachBusiness/teachBusinessAttache/teacherListFormal.vue"),
        meta: {
          title: '教师管理-正式表',
          breadList: ['教务', '教务专员', '教师管理-正式表'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessAttache/teacherListReserve",
        name: "teachBusinessAttache_teacherListReserve",
        component: () =>
          import(/* webpackChunkName: "teachBusinessAttache_teacherListReserve" */ "../views/teachBusiness/teachBusinessAttache/teacherListReserve.vue"),
        meta: {
          title: '教师管理-储备表',
          breadList: ['教务', '教务专员', '教师管理-储备表'],
        },
      },
      /* 教务主管 */
      {
        path: "/teachBusiness/teachBusinessSupervisor/dayPreview",
        name: "teachBusinessSupervisor_dayPreview",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_dayPreview" */ "../views/teachBusiness/teachBusinessAttache/dayPreview.vue"),
        meta: {
          title: '每日看板',
          breadList: ['教务', '教务主管', '每日看板'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/dayPreviewDetail",
        name: "teachBusinessSupervisor_dayPreviewDetail",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_dayPreviewDetail" */ "../views/teachBusiness/teachBusinessAttache/dayPreviewDetail.vue"),
        meta: {
          title: '每日看板',
          activeMenu: '/teachBusiness/teachBusinessSupervisor/dayPreview',
          breadList: ['教务', '教务主员', '每日看板', "看板信息"],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/studentList",
        name: "teachBusinessSupervisor_studentList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_studentList" */ "../views/teachBusiness/teachBusinessSupervisor/studentList.vue"),
        meta: {
          title: '部门学员',
          breadList: ['教务', '教务主管', '部门学员'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/courseList",
        name: "teachBusinessSupervisor_courseList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_courseList" */ "../views/teachBusiness/teachBusinessAttache/courseList.vue"),
        meta: {
          title: '部门课表',
          breadList: ['教务', '教务主管', '部门课表'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/monitorClass",
        name: "teachBusinessSupervisor_monitorClass",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_monitorClass" */ "../views/teachBusiness/teachBusinessAttache/monitorClass.vue"),
        meta: {
          title: '监课管理',
          breadList: ['教务', '教务主管', '监课管理'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/playbackList",
        name: "teachBusinessSupervisor_playbackList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_playbackList" */ "../views/teachBusiness/teachBusinessAttache/playbackList.vue"),
        meta: {
          title: '回放管理',
          breadList: ['教务', '教务主管', '回放管理'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/refundAudit",
        name: "teachBusinessSupervisor_refundAudit",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_refundAudit" */ "../views/teachBusiness/teachBusinessSupervisor/refundAudit.vue"),
        meta: {
          title: '退款审核',
          breadList: ['教务', '教务主管', '退款审核'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/teachBusinessList",
        name: "teachBusinessSupervisor_teachBusinessList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_teachBusinessList" */ "../views/teachBusiness/teachBusinessSupervisor/teachBusinessList.vue"),
        meta: {
          title: '人员管理',
          breadList: ['教务', '教务主管', '人员管理'],
        },
      },
      {
        path: "/teachBusiness/teachBusinessSupervisor/performanceList",
        name: "teachBusinessSupervisor_performanceList",
        component: () =>
          import(/* webpackChunkName: "teachBusinessSupervisor_performanceList" */ "../views/teachBusiness/teachBusinessSupervisor/performanceList.vue"),
        meta: {
          title: '部门业绩',
          breadList: ['教务', '教务主管', '部门业绩'],
        },
      },
      /* 销售专员 我的助手 */
      /* 拨打列表 */
      {
        path: "/saleBot/botCallList",
        name: "botCallList",
        component: () =>
          import(/* webpackChunkName: "botCallList" */ "../views/sales/saleStaff/botCallList.vue"),
        meta: {
          title: '拨打列表',
          breadList: ["销售", '销售助手', '拨打列表'],
        },
      },
      /* 拨打记录 */
      {
        path: "/saleBot/botCallHistoryList",
        name: "botCallHistoryList",
        component: () =>
          import(/* webpackChunkName: "botCallHistoryList" */ "../views/sales/saleStaff/botCallHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ["销售", '销售助手', '拨打记录'],
        },
      },
      /* 拨打记录 */
      /* 销售助手相关设置 */
      /* 开场白管理 */
      {
        path: "/saleBot/saleBotPrologueList",
        name: "saleBotPrologueList",
        component: () =>
          import(/* webpackChunkName: "saleBotPrologueList" */ "../views/ai/saleBotPrologueList.vue"),
        meta: {
          title: '开场白管理',
          breadList: ['销售助手', '开场白管理'],
        },
      },
      /* 音色管理 */
      {
        path: "/saleBot/saleBotVoiceList",
        name: "saleBotVoiceList",
        component: () =>
          import(/* webpackChunkName: "saleBotVoiceList" */ "../views/ai/saleBotVoiceList.vue"),
        meta: {
          title: '音色管理',
          breadList: ['销售助手', '音色管理'],
        },
      },
      /* 机器人设置 */
      {
        path: "/saleBot/saleBotSet",
        name: "saleBotSet",
        component: () =>
          import(/* webpackChunkName: "saleBotSet" */ "../views/ai/saleBotSet.vue"),
        meta: {
          title: '机器人管理',
          breadList: ['销售助手', '机器人管理'],
        },
      },
      /* 业务线管理 */
      {
        path: "/saleBot/saleBotBusinessLineList",
        name: "saleBotBusinessLineList",
        component: () =>
          import(/* webpackChunkName: "saleBotBusinessLineList" */ "../views/ai/saleBotBusinessLineList.vue"),
        meta: {
          title: '业务线管理',
          breadList: ['销售助手', '业务线管理'],
        },
      },
      /* 助手管理 */
      {
        path: "/saleBot/saleBotList",
        name: "saleBotList",
        component: () =>
          import(/* webpackChunkName: "saleBotList" */ "../views/ai/saleBotList.vue"),
        meta: {
          title: '助手管理',
          breadList: ['销售助手', '助手管理'],
        },
      },
      /* 拨打记录 */
      {
        path: "/saleBot/all/botCallHistoryList",
        name: "all_botCallHistoryList",
        component: () =>
          import(/* webpackChunkName: "botCallHistoryList" */ "../views/sales/saleStaff/botCallHistoryList.vue"),
        meta: {
          title: '拨打记录',
          breadList: ["销售助手",  '拨打记录'],
        },
      },
      /* 机器人拨打统计 */
      {
        path: "/saleBot/all/aiCallStatistics",
        name: "aiCallStatistics",
        component: () =>
          import(/* webpackChunkName: "aiCallStatistics" */ "../views/ai/aiCallStatistics.vue"),
        meta: {
          title: '拨打统计',
          breadList: ["销售助手",  '拨打统计'],
        },
      },
      /* 北文小程序 1+3列表 总帐号 */
      {
        path: "/bwMini/bwActivityList",
        name: "bwActivityList",
        component: () =>
          import(/* webpackChunkName: "bwActivityList" */ "../views/bwMini/bwActivityList.vue"),
        meta: {
          title: '1+3列表',
          breadList: ['北文小程序', '1+3列表'],
        },
      },
      /* 北文小程序 1+3列表 销售主管 */
      {
        path: "/sales/saleLeader/bwActivityList",
        name: "saleLeader_bwActivityList",
        component: () =>
          import(/* webpackChunkName: "bwActivityList" */ "../views/bwMini/bwActivityList.vue"),
        meta: {
          title: '1+3列表',
          breadList: ['北文小程序', '1+3列表'],
        },
      },
      /* 北文小程序 课程列表 总帐号 */
      {
        path: "/bwMini/bwCourseList",
        name: "bwCourseList",
        component: () =>
          import(/* webpackChunkName: "bwCourseList" */ "../views/bwMini/bwCourseList.vue"),
        meta: {
          title: '课程列表',
          breadList: ['北文小程序', '课程列表'],
        },
      },
      /* 北文小程序 课程列表 销售主管 */
      {
        path: "/sales/saleLeader/bwCourseList",
        name: "saleLeader_bwCourseList",
        component: () =>
          import(/* webpackChunkName: "bwCourseList" */ "../views/bwMini/bwCourseList.vue"),
        meta: {
          title: '课程列表',
          breadList: ['北文小程序', '课程列表'],
        },
      },
      /* 北文小程序 试听课列表 */
      {
        path: "/bwMini/bwTrialClassList",
        name: "bwTrialClassList",
        component: () =>
          import(/* webpackChunkName: "bwTrialClassList" */ "../views/bwMini/bwTrialClassList.vue"),
        meta: {
          title: '试听课列表',
          breadList: ['北文小程序', '试听课列表'],
        },
      },
      /* 北文小程序 关联订单列表 */
      {
        path: "/bwMini/bwRelateOrderList",
        name: "bwRelateOrderList",
        component: () =>
          import(/* webpackChunkName: "bwRelateOrderList" */ "../views/bwMini/bwRelateOrderList.vue"),
        meta: {
          title: '与我有关订单',
          breadList: ['北文小程序', '与我有关订单'],
        },
      },
      /* 北文小程序 资讯列表 */
      {
        path: "/bwMini/bwNewsList",
        name: "bwNewsList",
        component: () =>
          import(/* webpackChunkName: "bwNewsList" */ "../views/bwMini/bwNewsList.vue"),
        meta: {
          title: '资讯列表',
          breadList: ['北文小程序', '资讯列表'],
        },
      },
      /* 北文小程序 用户列表 */
      {
        path: "/bwMini/bwUserList",
        name: "bwUserList",
        component: () =>
          import(/* webpackChunkName: "bwUserList" */ "../views/bwMini/bwUserList.vue"),
        meta: {
          title: '用户列表',
          breadList: ['北文小程序', '用户列表'],
        },
      },
      /* 北文小程序 订单列表 总帐号 */
      {
        path: "/bwMini/bwOrderList",
        name: "bwOrderList",
        component: () =>
          import(/* webpackChunkName: "bwOrderList" */ "../views/bwMini/bwOrderList.vue"),
        meta: {
          title: '订单列表',
          breadList: ['北文小程序', '订单列表'],
        },
      },
      /* 北文小程序 订单列表 销售主管 */
      {
        path: "/sales/saleLeader/bwOrderList",
        name: "saleLeader_bwOrderList",
        component: () =>
          import(/* webpackChunkName: "bwOrderList" */ "../views/bwMini/bwOrderList.vue"),
        meta: {
          title: '订单列表',
          breadList: ['北文小程序', '订单列表'],
        },
      },
      /* 北文小程序 基础设置 */
      {
        path: "/bwMini/bwMinConfig",
        name: "bwMinConfig",
        component: () =>
          import(/* webpackChunkName: "bwMinConfig" */ "../views/bwMini/bwMinConfig.vue"),
        meta: {
          title: '基础设置',
          breadList: ['北文小程序', '基础设置'],
        },
      },
      /* 北文小程序 所有试听课列表 总帐号 */
      {
        path: "/bwMini/bwAllTrialClassList",
        name: "bwAllTrialClassList",
        component: () =>
          import(/* webpackChunkName: "bwAllTrialClassList" */ "../views/bwMini/bwAllTrialClassList.vue"),
        meta: {
          title: '销售试听课',
          breadList: ['北文小程序', '销售试听课'],
        },
      },
      /* 北文小程序 所有试听课列表 销售主管 */
      {
        path: "/sales/saleLeader/bwAllTrialClassList",
        name: "saleLeader_bwAllTrialClassList",
        component: () =>
          import(/* webpackChunkName: "bwAllTrialClassList" */ "../views/bwMini/bwAllTrialClassList.vue"),
        meta: {
          title: '销售试听课',
          breadList: ['北文小程序', '销售试听课'],
        },
      },
      /* 北文小程序 退费审核 */
      {
        path: "/bwMini/bwOrderRefundAudit",
        name: "bwOrderRefundAudit",
        component: () =>
          import(/* webpackChunkName: "bwOrderRefundAudit" */ "../views/bwMini/bwOrderRefundAudit.vue"),
        meta: {
          title: '小程序订单退费审核',
          breadList: ['财务', '小程序订单退费审核'],
        },
      },
    ]
  },
  {
    path: '*',
    name: 'notFound',
    component: notFound,
    meta: {
      title: '404'
    }
  }
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(to => {
  NProgress.done()
  document.title = to.meta.title
})
export default router;
